import { Component } from 'react';
import '../styles/Holding.css';

const THEMES = [
  { id: 'midnight', label: 'Midnight', color: '#0A1628' },
  { id: 'desert', label: 'Desert', color: '#C8956C' },
  { id: 'oasis', label: 'Oasis', color: '#2D6A4F' },
  { id: 'arctic', label: 'Arctic', color: '#E8EDF2' },
];

const PRODUCTS = [
  {
    name: 'Square Meter',
    taglineAr: 'متر مربع',
    description:
      'All-in-one real estate operations platform. Manage ad campaigns across Snapchat, TikTok, Instagram, and Google Ads, handle customer conversations, track sales and inventory — from one Arabic-first dashboard.',
    status: 'Live',
    url: '/square-meter',
    cta: 'Learn More',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-product-icon">
        <rect x="6" y="6" width="36" height="36" rx="4" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <rect x="14" y="14" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.5" />
        <line x1="24" y1="6" x2="24" y2="42" stroke="currentColor" strokeWidth="1.5" opacity="0.3" />
        <line x1="6" y1="24" x2="42" y2="24" stroke="currentColor" strokeWidth="1.5" opacity="0.3" />
      </svg>
    ),
  },
  {
    name: 'Khitab',
    taglineAr: 'خطاب',
    description:
      'AI-powered formal letter generator for Arabic. Create professional official correspondence — transfer letters, leave requests, internal memos, and more — in seconds using artificial intelligence.',
    status: 'Live',
    url: '/khitab',
    cta: 'Learn More',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-product-icon">
        <path d="M8 12C8 10.8954 8.89543 10 10 10H38C39.1046 10 40 10.8954 40 12V36C40 37.1046 39.1046 38 38 38H10C8.89543 38 8 37.1046 8 36V12Z" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <path d="M8 12L24 26L40 12" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <line x1="16" y1="30" x2="24" y2="30" stroke="currentColor" strokeWidth="1.5" opacity="0.4" />
        <line x1="16" y1="34" x2="20" y2="34" stroke="currentColor" strokeWidth="1.5" opacity="0.3" />
      </svg>
    ),
  },
  {
    name: 'Saree',
    taglineAr: 'سريع',
    description:
      'WhatsApp auto-reply and order management for businesses. Customers message you, get an instant menu, place orders — and your team manages everything from one dashboard.',
    status: 'Live',
    url: '/saree',
    cta: 'Learn More',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-product-icon">
        <path d="M6 12C6 10.8954 6.89543 10 8 10H40C41.1046 10 42 10.8954 42 12V32C42 33.1046 41.1046 34 40 34H18L10 42V34H8C6.89543 34 6 33.1046 6 32V12Z" stroke="currentColor" strokeWidth="2.5" fill="none" />
        <line x1="14" y1="18" x2="34" y2="18" stroke="currentColor" strokeWidth="2" opacity="0.5" />
        <line x1="14" y1="24" x2="28" y2="24" stroke="currentColor" strokeWidth="2" opacity="0.3" />
        <circle cx="36" cy="12" r="5" fill="currentColor" opacity="0.6" />
        <path d="M34 12L35.5 13.5L38.5 10.5" stroke="currentColor" strokeWidth="1.5" opacity="0.9" />
      </svg>
    ),
  },
];

class Holding extends Component {
  constructor(props) {
    super(props);
    const saved = localStorage.getItem('holding-theme') || 'midnight';
    const savedDark = localStorage.getItem('holding-dark') !== 'false';
    this.state = { theme: saved, darkMode: savedDark, notifyEmail: '', notifySubmitted: false };
  }

  setTheme = (id) => {
    localStorage.setItem('holding-theme', id);
    this.setState({ theme: id });
  };

  toggleDarkMode = () => {
    const next = !this.state.darkMode;
    localStorage.setItem('holding-dark', next);
    this.setState({ darkMode: next });
  };

  handleNotify = (e) => {
    e.preventDefault();
    if (this.state.notifyEmail) {
      this.setState({ notifySubmitted: true });
    }
  };

  render() {
    const { theme, darkMode } = this.state;
    const year = new Date().getFullYear();
    const modeClass = darkMode ? 'h-dark' : 'h-light';

    return (
      <div className={`h-root h-theme-${theme} ${modeClass}`}>
        {/* Navigation */}
        <nav className="h-nav">
          <div className="h-nav-inner">
            <a href="/" className="h-nav-logo">
              <img
                src="/images/rakeen-logo.png"
                alt="Rakeen"
                className="h-nav-logo-img"
              />
              <span className="h-nav-logo-text">Rakeen</span>
            </a>
            <div className="h-nav-links">
              <a href="#products" className="h-nav-link">Products</a>
              <a href="#about" className="h-nav-link">About</a>
              <a href="/contact" className="h-nav-link">Contact</a>
              <button
                className="h-dark-toggle"
                onClick={this.toggleDarkMode}
                aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                title={darkMode ? 'Light mode' : 'Dark mode'}
              >
                {darkMode ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="5"/>
                    <line x1="12" y1="1" x2="12" y2="3"/>
                    <line x1="12" y1="21" x2="12" y2="23"/>
                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                    <line x1="1" y1="12" x2="3" y2="12"/>
                    <line x1="21" y1="12" x2="23" y2="12"/>
                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </nav>

        {/* Theme Switcher */}
        <div className="h-theme-switcher">
          {THEMES.map((t) => (
            <button
              key={t.id}
              className={`h-theme-dot ${theme === t.id ? 'active' : ''}`}
              style={{ '--dot-color': t.color }}
              onClick={() => this.setTheme(t.id)}
              title={t.label}
              aria-label={`Switch to ${t.label} theme`}
            />
          ))}
        </div>

        {/* Hero */}
        <section className="h-hero">
          <div className="h-hero-bg-pattern" aria-hidden="true" />
          <div className="h-hero-content">
            <div className="h-hero-badge">Khobar, Saudi Arabia</div>
            <h1 className="h-hero-title">
              Building products that move<br />
              <span className="h-hero-accent">Saudi Arabia</span> forward
            </h1>
            <p className="h-hero-subtitle">
              Rakeen is a technology holding company creating software
              that transforms how businesses market, communicate, and operate.
            </p>
            <div className="h-hero-stats">
              <div className="h-stat">
                <span className="h-stat-number">3</span>
                <span className="h-stat-label">Products</span>
              </div>
              <div className="h-stat-divider" />
              <div className="h-stat">
                <span className="h-stat-number">3</span>
                <span className="h-stat-label">Live Platforms</span>
              </div>
              <div className="h-stat-divider" />
              <div className="h-stat">
                <span className="h-stat-number">KSA</span>
                <span className="h-stat-label">Headquartered</span>
              </div>
            </div>
          </div>
          <div className="h-hero-scroll-hint" aria-hidden="true">
            <span>Scroll</span>
            <div className="h-scroll-line" />
          </div>
        </section>

        {/* Products */}
        <section className="h-products" id="products">
          <div className="h-section-inner">
            <div className="h-section-header">
              <span className="h-section-tag">Our Portfolio</span>
              <h2 className="h-section-title">Three products. One mission.</h2>
              <p className="h-section-subtitle">
                Each product tackles a different challenge Saudi businesses face daily.
              </p>
            </div>

            <div className="h-products-grid">
              {PRODUCTS.map((product, i) => (
                <div key={i} className={`h-product-card ${product.status === 'In Development' ? 'h-card-coming' : ''}`}>
                  <div className="h-card-top">
                    <div className="h-card-icon-wrap">
                      {product.icon}
                    </div>
                    <span className={`h-card-status ${product.status === 'Live' ? 'h-status-live' : 'h-status-dev'}`}>
                      {product.status === 'Live' && <span className="h-status-dot" />}
                      {product.status}
                    </span>
                  </div>
                  <h3 className="h-card-name">{product.name}</h3>
                  <span className="h-card-arabic">{product.taglineAr}</span>
                  <p className="h-card-desc">{product.description}</p>
                  <div className="h-card-bottom">
                    <a href={product.url} className="h-card-cta">
                      {product.cta}
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About */}
        <section className="h-about" id="about">
          <div className="h-section-inner">
            <div className="h-about-grid">
              <div className="h-about-left">
                <span className="h-section-tag">Who We Are</span>
                <h2 className="h-section-title">From Khobar to the Kingdom</h2>
                <p className="h-about-text">
                  Rakeen — registered as Durrat Rakeen for Business Solutions — started
                  as a collaboration with Al-Yem to digitize real estate operations.
                  Today, we are a holding company with a growing portfolio of SaaS
                  products serving businesses across Saudi Arabia.
                </p>
                <p className="h-about-text">
                  We believe in building focused, purposeful tools. Each product in
                  our portfolio solves one problem exceptionally well, rather than
                  trying to do everything at once.
                </p>
                <div className="h-about-details">
                  <div className="h-detail">
                    <span className="h-detail-label">Legal Name</span>
                    <span className="h-detail-value">Durrat Rakeen for Business Solutions</span>
                  </div>
                  <div className="h-detail">
                    <span className="h-detail-label">CR Number</span>
                    <a
                      href="https://mc.gov.sa/en/eservices/Pages/Commercial-data.aspx"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-detail-value h-detail-link"
                    >
                      7051429145
                    </a>
                  </div>
                  <div className="h-detail">
                    <span className="h-detail-label">Location</span>
                    <span className="h-detail-value">Khobar, Saudi Arabia</span>
                  </div>
                </div>
              </div>
              <div className="h-about-right">
                <div className="h-about-visual">
                  <div className="h-visual-ring h-ring-1" />
                  <div className="h-visual-ring h-ring-2" />
                  <div className="h-visual-ring h-ring-3" />
                  <div className="h-visual-center">
                    <img
                      src="/images/rakeen-logo.png"
                      alt="Rakeen"
                      className="h-visual-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="h-footer">
          <div className="h-footer-inner">
            <div className="h-footer-top">
              <div className="h-footer-brand">
                <img
                  src="/images/rakeen-logo.png"
                  alt="Rakeen"
                  className="h-footer-logo"
                />
                <span className="h-footer-name">Rakeen</span>
              </div>
              <div className="h-footer-links">
                <a href="/privacy" className="h-footer-link">Privacy</a>
                <a href="/terms" className="h-footer-link">Terms</a>
                <a href="/contact" className="h-footer-link">Contact</a>
              </div>
            </div>
            <div className="h-footer-bottom">
              <span>&copy; {year} Rakeen. All rights reserved.</span>
              <span className="h-footer-location">Khobar, Saudi Arabia</span>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Holding;
